var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        staticStyle: { "padding-top": "80px" },
        attrs: { id: "navigationPlaceholder" },
      },
      [_c("AdminNavigationV2", { attrs: { tid: _vm.tid } })],
      1
    ),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("hr", {
      staticStyle: { "border-color": "#bbb", margin: "20px 0 30px" },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c(
        "ul",
        { staticClass: "list-group list-group-flush" },
        _vm._l(_vm.results, function (r) {
          return _c("li", { staticClass: "list-group-item" }, [
            _c("div", { staticClass: "d-flex w-100 justify-content-between" }, [
              _c("h5", { staticClass: "mb-1" }, [
                r.Type == "User"
                  ? _c("i", {
                      staticClass: "fa fa-user",
                      attrs: { "aria-hidden": "true" },
                    })
                  : r.Type == "Workspace"
                  ? _c("i", {
                      staticClass: "fa fa-folder",
                      attrs: { "aria-hidden": "true" },
                    })
                  : r.Type == "Portfolio"
                  ? _c("i", {
                      staticClass: "fa fa-book",
                      attrs: { "aria-hidden": "true" },
                    })
                  : _vm._e(),
                _vm._v(" "),
                r.Url
                  ? _c("a", { attrs: { href: r.Url, target: "_blank" } }, [
                      _vm._v(_vm._s(r.Type) + " " + _vm._s(r.Title)),
                    ])
                  : _c("span", [
                      _vm._v(_vm._s(r.Type) + " " + _vm._s(r.Title)),
                    ]),
              ]),
              _vm._v(" "),
              _c("div", [
                r.AdminUrl
                  ? _c("a", { attrs: { href: r.AdminUrl, target: "_blank" } }, [
                      _c("span", [_vm._v("Manage")]),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c("small", [_vm._v(_vm._s(r.Details))]),
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c("br"),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-7" }, [
          _c(
            "h1",
            {
              staticStyle: {
                "font-size": "2em",
                "font-weight": "300",
                color: "#33475b",
              },
            },
            [_vm._v("Search results")]
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }